module.exports = __webpack_public_path__ + "static/media/13.a1b72010.jpg";